<template>
  <div class="order-page">
    <div class="container">
      <search-part @add="add" @addAli="addAli" @batchAddAli="batchAddAli" @addBatchOut="addBatchOut"
                   @addOrder="addOrder" @search="searchResult"
                   @batchAddBatchOut="batchAddBatchOut"></search-part>
      <div class="order-list">
        <el-row class="order-list-header">
          <el-col :span="2">业务类型</el-col>
          <el-col :span="4">业务单据号</el-col>
          <el-col :span="5">来源单位</el-col>
          <el-col :span="5">去向单位</el-col>
          <el-col :span="3">业务时间</el-col>
          <el-col :span="3">创建时间</el-col>
          <el-col :span="2">状态</el-col>
        </el-row>
        <el-row v-if="loadingData">
          <el-col :span="24">
            <oms-loading :loading="loadingData"></oms-loading>
          </el-col>
        </el-row>
        <el-row v-else-if="!orderList.length">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div class="order-list-body flex-list-dom" v-else="">
          <div :class="[{'active':currentOrderId===item.id}]" @click.prevent="showItem(item)"
               class="order-list-item order-list-item-bg"
               v-for="item in orderList">
            <el-row>
              <el-col :span="2">{{ filterBizType(item.bizType) }}</el-col>
              <el-col :span="4" class="R">{{ item.objectNo }}</el-col>
              <el-col :span="5">{{ item.sourceOrgName }}</el-col>
              <el-col :span="5">{{ item.directionOrgName }}</el-col>
              <el-col :span="3">{{ item.operateTime | minute }}</el-col>
              <el-col :span="3">{{ item.createTime | minute }}</el-col>
              <el-col :span="2">
                <el-tag :type="bizTraceUploadStatus[item.status].tag"
                        v-if="item.status&&bizTraceUploadStatus[item.status]">
                  {{ bizTraceUploadStatus[item.status].label }}
                </el-tag>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-show="orderList.length && !loadingData">
      <el-pagination
        :current-page="pager.currentPage"
        :pageSize="pager.pageSize" :total="pager.count" @current-change="getOrderList" @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next">
      </el-pagination>
    </div>

    <page-right :css="{'width':'800px','padding':0}" :show="showItemRight" @right-close="resetRightBox">
      <add-form :defaultIndex="defaultIndex" @close="resetRightBox" @refresh="refresh"
                type="0"></add-form>
    </page-right>

    <page-right :css="{'width':'800px','padding':0}" :show="showALiItemRight" @right-close="resetRightBox">
      <add-a-li-form :defaultIndex="defaultIndex" @close="resetRightBox" @refresh="refresh"
                     type="0"></add-a-li-form>
    </page-right>
    <page-right :css="{'width':'800px','padding':0}" :show="showBatchOutItemRight" @right-close="resetRightBox">
      <batch-out-form :defaultIndex="defaultIndex" @close="resetRightBox" @refresh="refresh"
                      type="0"></batch-out-form>
    </page-right>
    <page-right :css="{'width':'800px','padding':0}" :show="showOrderRight" @right-close="resetRightBox">
      <order-form :defaultIndex="defaultIndex" @close="resetRightBox" @refresh="refresh"
                  type="0"></order-form>
    </page-right>

    <page-right :css="{'width':'1000px','padding':0}" :show="showDetail" @right-close="resetRightBox"
                class="order-detail-info" partClass="pr-no-animation">
      <show-form :filterBizType="filterBizType" :orderId="currentOrderId" @close="resetRightBox"></show-form>
    </page-right>
    <page-right :css="{'width':'800px','padding':0}" :show="showImportRight" @right-close="resetRightBox">
      <import-form @change="itemChange" @right-close="resetRightBox"></import-form>
    </page-right>
  </div>
</template>
<script>
import showForm from './form/show.form.vue';
import DataMixin from '@/mixins/dataMixin';
import SearchPart from './search';
import addForm from './form/addForm.vue';
import addALiForm from './form/addALiForm'
import batchOutForm from './form/addBatchOutForm'
import orderForm from './form/addOrderForm'
import importForm from './form/import-excel'

export default {
  components: {showForm, SearchPart, addForm, addALiForm, batchOutForm, orderForm, importForm},
  mixins: [DataMixin],
  data: function () {
    return {
      loadingData: true,
      showDetail: false,
      showSearch: true,
      showItemRight: false,
      showALiItemRight: false,
      showBatchALiItemRight: false,
      showBatchOutItemRight: false,
      showOrderRight: false,
      showImportRight: false,
      orderList: [],
      filters: {},
      defaultIndex: 0,
      currentOrderId: '',
      pager: {
        currentPage: 1,
        count: 0,
        pageSize: 20
      }
    };
  },
  mounted() {
    this.getOrderList(1);
    let id = this.$route.params.id;
    id !== 'id' && this.showItem({id});
  },
  watch: {
    filters: {
      handler: function () {
        this.getOrderList(1);
      },
      deep: true
    }
  },
  methods: {
    itemChange: function (item) {
      this.getOrderList(this.pager.currentPage);
    },
    searchResult: function (search) {
      this.filters = Object.assign({}, this.filters, search);
    },
    resetRightBox: function () {
      this.showDetail = false;
      this.showItemRight = false;
      this.showALiItemRight = false;
      this.showBatchOutItemRight = false;
      this.showOrderRight = false;
      this.showImportRight = false;
      this.defaultIndex = 0;
      this.$router.push('/retrospect/business/import/id');
    },
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.getOrderList(1);
    },
    getOrderList: function (pageNo) {
      if (pageNo === 1) {
        this.pager.count = 0;
      }
      this.pager.currentPage = pageNo;
      let param = {};
      this.loadingData = true;
      param = Object.assign({}, this.filters, {
        pageNo: pageNo,
        pageSize: this.pager.pageSize
      });
      this.$http.get('/code-biz/file/pager', {params: param})
        // bizTraces.query(param)
        .then(res => {
          this.orderList = res.data.list;
          this.pager.count = res.data.count;
          this.loadingData = false;
        });
    },
    refresh(obj) {
      this.resetRightBox();
      if (obj && obj.id) {
        this.showItem(obj);
      }
      this.getOrderList(1);
    },
    add() {
      this.showItemRight = true;
      this.defaultIndex = 1;
    },
    addAli() {
      this.showALiItemRight = true;
      this.defaultIndex = 2;
    },
    batchAddAli() {
      console.log('11');
      this.$router.push('/retrospect/business/batch-add');
    },
    addBatchOut() {
      this.showBatchOutItemRight = true;
      this.defaultIndex = 3;
    },
    addOrder() {
      this.showOrderRight = true;
      this.defaultIndex = 4;
    },
    batchAddBatchOut() {
      this.showImportRight = true;
      this.defaultIndex = 5;
    },
    showItem: function (order) {
      this.currentOrderId = order.id;
      this.showDetail = true;
      this.$router.push(`/retrospect/business/import/${order.id}`);
    },
    formatTimeAry(times, index, str) {
      if (!times) return;
      return this.formatTime(times[index], str);
    },
    formatTime(time, str = 'YYYY-MM-DD HH:mm:ss') {
      return time ? this.$moment(time).format(str) : '';
    }
  }
};
</script>
